import { render, staticRenderFns } from "./picture-component.vue?vue&type=template&id=15e496fc&"
import script from "./picture-component.vue?vue&type=script&lang=js&"
export * from "./picture-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports